export const APPLICATION_STATUS_LABEL_MAP: Record<string, string> = {
  todo: '待處理',
  processing: '待派案',
  assigned: '指定派案',
  completed: '已完成',
  accept: '已收案',
  rejected: '不符合資格',
};

